// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vlLr","badges":"styles_badges__1pDU1"};